import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { IMerchant } from '../../merchants/types';

import { ICredential, IIntegration, IProviderListData, IUpdateProviderLogo } from './types';

export const fetchProvidersRequest = async (params: IQueryParams, searchRequest: IQueryParams): Promise<IProviderListData | null> => {
  try {
    const res = await axios.post('api/v1/providers/activity', searchRequest, { params });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch providers");
    return null;
  }
};

export const setActiveProvider = async (id: number, body: { active: boolean }) => {
  try {
    const res = await axios.put(`api/v1/providers/${id}/activity`, body);

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch activate provider");

    return null;
  }
};

export const fetchProvidersMerchantsRequest = async ({ page, size, ...data }: IQueryParams): Promise<IProviderListData | null> => {
  try {
    const res = await axios.post('api/v1/providers/payment/merchant-accounts', data, { params: { page, size } });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch providers");
    return null;
  }
};

export const fetchMerchantsRequest = async (): Promise<IMerchant[]> => {
  try {
    const res = await axios.get('api/v1/merchants', { params: { page: 0, size: 100 } });
    return res.data?.content;
  } catch (error) {
    NotificationManager.error("Can't fetch merchants");
    return [];
  }
};

export const fetchIntegrationRequest = async (type: string, providerIds: number[]): Promise<IIntegration[]> => {
  try {
    const res = await axios.post(`api/v1/${type}/integrations/get-all-filtered`, { providerIds });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch integration");
    return [];
  }
};

export const fetchCredentialsRequest = async (type: string, name: string): Promise<ICredential[]> => {
  try {
    const res = await axios.get(`api/v1/${type}/merchant-accounts-credentials/${name}`);
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch credentials");
    return [];
  }
};

export const createMerchantRequest = async (type: string, data: Partial<IMerchant>): Promise<Partial<IMerchant>> => {
  const res = await axios.put(`api/v1/${type}/merchant-accounts`, data);
  return res.data;
};

export const deleteProviderImageRequest = async (id: string): Promise<void> => {
  return await axios.delete(`api/v1/providers/${id}/logo`);
};

export const updateProviderImageRequest = async ({ id, logo }: IUpdateProviderLogo): Promise<void> => {
  return await axios.put(`api/v1/providers/${id}/logo`, logo);
};
